import { APP_INITIALIZER, inject } from '@angular/core';
import { ABP, RoutesService } from '@abp/ng.core';
import { API_STATUS_BASE_ROUTES } from './api-status-base.routes';

export const API_STATUSES_API_STATUS_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: configureRoutes,
  },
];

function configureRoutes() {
  const routesService = inject(RoutesService);

  return () => {
    const routes: ABP.Route[] = [...API_STATUS_BASE_ROUTES];
    routesService.add(routes);
  };
}
